var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('main-title',[_vm._v("\n    "+_vm._s(_vm.sectionTItle)+"\n  ")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.sectionDescription))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }